<template>
	<div class="sideways-content-fold" v-if="activePanel">
		<div class="portlet light bordered">
			<div class="portlet-title">
				<div class="caption">
					Edit Role Name
				</div>
			</div>
			<div class="portlet-body">
				<form role="form" novalidate @submit.prevent="modifyRole($event)">
					<div class="alert alert-danger" v-if="errorMessage.length">
					    <button class="close" data-close="alert" @click="clearError()"></button>
                        <span>{{ errorMessage }}</span>
					</div>
					<div class="form-body invite-user-form">
						<div class="form-group form-md-line-input form-md-floating-label">
                            <input type="text" class="form-control input-sm" :class="{'edited': editingRole.role_name.length}" id="edit_role_name" v-model="editingRole.role_name">
                            <label for="edit_role_name">Role Name</label>
                        </div>
					</div>
					<div class="form-actions noborder invite-user-actions">
						<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To Roles Dashboard</button>
						<button type="submit" class="btn blue" :disabled="!editingRole.role_name.length">Submit</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>
<script>
import $ from 'jquery'
import GlobalFunctions from '../../../../global'
import Role from '../../../../controllers/Roles'

/**
 * Edit Role Name module is a page for editing the name of a role.
 * @class EditRoleName
 * @extends Roles
 * @prop {string} baseRoute - The route of the component that this is being called from.
 * @prop {string} baseRouteName - The name of the route of the component that this is being called from.
 * @since 0.0.6
 */

export default {
	name: 'edit-role-name',
	props: {
		baseRoute: {
			type: String,
			required: true
		},
		baseRouteName: {
			type: String,
			required: true
		}
	},
	data () {
		return {
			activePanel: false,
			errorMessage: '',
			editingRole: {
				role_name: ''
			},
			roleId: 0
		}
	},
	/**
	 * Run on created to determine if this should be the active panel or not.
	 * @function
	 * @return {undefined}
	 * @memberof EditRoleName
	 * @version 0.0.8
	 */
	created () {
		if (this.$route.name === this.baseRouteName + ' - Edit Role Name') {
			this.activePanel = true
			if (this.$route.params.role_id && this.$route.params.role_id !== 'undefined' && parseInt(this.$route.params.role_id) !== 0) {
				this.roleId = this.$route.params.role_id
				this.getRole()
			} else {
				this.closePanel()
			}
		} else {
			this.activePanel = false
		}
	},
	methods: {
		/**
		 * To clear the current error.
		 * @function
		 * @returns {undefined}
		 * @memberof EditRoleName
		 * @version 0.0.6
		 */
		clearError () {
			this.errorMessage = ''
		},
		/**
		 * To check if the name is valid before submitting to the backend.
		 * @function
		 * @return {object} A promise that will validate the input form
		 * @memberof EditRoleName
		 * @version 0.0.6
		 */
		validateRoleData () {
			let _this = this
			return new Promise((resolve, reject) => {
				if (!_this.editingRole.role_name.length) {
					reject('Role name cannot be blank')
				}
				resolve()
			})
		},
		/**
		 * To get details for the current role.
		 * @function
		 * @return {undefined}
		 * @memberof EditRoleName
		 * @version 0.0.6
		 */
		getRole () {
			let _this = this

			Role.getRole(_this.roleId).then(response => {
				_this.editingRole = response.payload
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {
					case 'role_not_found':
						_this.closePanel()
						break

					default:
							// No default
					}
				}
			}))
		},
		/**
		 * To send the updated details of the role to the backend.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof EditRoleName
		 * @version 0.0.6
		 */
		modifyRole (event) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			return _this.validateRoleData()
			.then(response => {
				_this.clearError()
				Role.modifyRole(_this.editingRole).then(response => {
					_this.closePanel()
					disabledButton.complete()
				}).catch(_this.$root.errorWrapper(e => {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
						case 'already_exists':
							_this.errorMessage = 'A role with this name already exists. Please choose a different name.'
							break

						case 'role_conflict':
							// This case should never happen.
							_this.closePanel()
							break

						case 'role_not_found':
							_this.errorMessage = 'The role you are trying to edit could not be found. Please try selecting another role.'
							break

						case 'locked_role':
							_this.errorMessage = 'The role you are trying to edit is a locked role. You cannot perform this action.'
							break

						case 'invalid_role':
							_this.errorMessage = 'You don\t have access to modify this role. Please try selecting another role.'
							break

						default:
							// No default
						}
					}
					disabledButton.cancel()
				}))
			}).catch(reason => {
				// If validation fails then display the error message
				_this.errorMessage = reason
				disabledButton.cancel()
			})
		},
		/**
		 * To clear the object 'editingRole'.
		 * @function
		 * @returns {undefined}
		 * @memberof EditRoleName
		 * @version 0.0.6
		 */
		clearForm () {
			this.editingRole = {
				role_name: ''
			}
			$('.invite-user-form').find('input, select').removeClass('edited')
		},
		/**
		 * To close the edit role name panel by redirecting to the dashboard
		 * @function
		 * @returns {undefined}
		 * @memberof EditRoleName
		 * @version 0.0.8
		 */
		closePanel () {
			this.$router.push(this.baseRoute)
		}
	},
	watch: {
		/**
		 * To `watch` the $route in order to determine if this panel should be showing or not
		 * @function
		 * @returns {undefined}
		 * @memberof EditRoleName
		 * @version 0.0.8
		 */
		'$route' () {
			if (this.$route.name === this.baseRouteName + ' - Edit Role Name') {
				this.activePanel = true
				this.clearError()
				this.clearForm()

				if (this.$route.params.role_id && this.$route.params.role_id !== 'undefined' && parseInt(this.$route.params.role_id) !== 0) {
					this.roleId = this.$route.params.role_id
					this.getRole()
				} else {
					this.closePanel()
				}
			} else {
				this.activePanel = false
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// EditRoleName.vue?0c06ade3